import { z } from 'zod';
import { PROFILE_NAME_MAX_LENGTH } from './signup';
export const emailLoginStartRequestSchema = z.object({
    email: z.email().max(254),
    locale: z.enum(['en', 'de']).optional(),
});
export const emailLoginVerifyRequestSchema = z.object({
    code: z.string().regex(/^\d{6}$/, 'code must be 6 digits'),
    locale: z.enum(['en', 'de']).optional(),
});
export const consentRequestSchema = z.object({
    decision: z.enum(['allow', 'deny']),
});
export const interactionStateSchema = z.object({
    uid: z.string(),
    prompt: z.enum(['login', 'consent']),
    client: z.object({
        clientId: z.string(),
        clientName: z.string(),
        logoUri: z.string().optional(),
    }),
    scopes: z.array(z.string()),
    grantedScopes: z.array(z.string()).default([]),
    csrfToken: z.string(),
    socialProviders: z.array(z.enum(['google', 'microsoft', 'apple'])),
    passkeysEnabled: z.boolean(),
    screenHint: z.literal('signup').optional(),
    profilePrefill: z
        .object({
        givenName: z.string().max(PROFILE_NAME_MAX_LENGTH).optional(),
        familyName: z.string().max(PROFILE_NAME_MAX_LENGTH).optional(),
    })
        .optional(),
    pending: z
        .discriminatedUnion('step', [
        z.object({ step: z.literal('code'), email: z.string() }),
        z.object({ step: z.literal('complete-profile'), email: z.string() }),
        z.object({ step: z.literal('offer-passkey') }),
        z.object({ step: z.literal('offer-password') }),
        z.object({ step: z.literal('require-birthdate') }),
        z.object({
            step: z.literal('require-terms'),
            documents: z.array(z.enum(['terms', 'privacy'])).min(1),
            account: z.object({ email: z.string() }).optional(),
        }),
    ])
        .optional(),
    idpHint: z.enum(['google', 'microsoft', 'apple']).optional(),
    minimumAge: z.number().int().positive().optional(),
});
export const codeSentResponseSchema = z.object({
    status: z.literal('code-sent'),
});
export const finishedResponseSchema = z.object({
    status: z.literal('finished'),
    redirectTo: z.string(),
});
export const errorResponseSchema = z.object({
    error: z.string(),
    message: z.string().optional(),
});
//# sourceMappingURL=interaction.js.map